import { defineMessages } from 'react-intl';

const signinMessages = defineMessages({
  header: {
    id: 'signin.header',
    defaultMessage: 'Sign in or Sign up',
    description: 'Main heading for sign in page.',
  },
  changeSigninOption: {
    id: 'signin.changeSigninOption',
    defaultMessage: 'Sign in with a different option',
    description: 'Action to see all available sign in options.',
  },
  organizationSigninButton: {
    id: 'signin.organizationSigninButton',
    defaultMessage: 'Organization SSO',
    description: 'Action to select to sign in through an organization.',
  },
  organizationSigninInfo: {
    id: 'signin.organizationSigninInfo',
    defaultMessage:
      'For enterprise single sign-on (SSO), please visit your company’s direct URL.',
    description:
      'Information to customers wanting to sign in through an organization.',
  },
  signInMechanismSeparator: {
    id: 'signin.signInMechanismSeparator',
    defaultMessage: 'Or',
    description:
      'Visually separates sign in mechanisms from each other vertically, adding "or" In between.',
  },
});

export default signinMessages;
